<template>
  <footer class="app-footer">
    <div class="container">
      <el-row :gutter="30">
        <!-- 公司信息 -->
        <el-col :span="6">
          <div class="footer-section">
            <h3>{{ $t('app.footer.shopTitle') }}</h3>
            <ul>
              <li><router-link to="/products/sim">{{ $t('app.footer.securityCameraSim') }}</router-link></li>
              <li><router-link to="/products/sim">{{ $t('app.footer.gpsSim') }}</router-link></li>
              <li><router-link to="/products/sim">{{ $t('app.footer.routerSim') }}</router-link></li>
              <li><router-link to="/products/sim">{{ $t('app.footer.industrialSim') }}</router-link></li>
              <li><router-link to="/products/esim">{{ $t('app.footer.vSim') }}</router-link></li>
              <li><router-link to="/products/esim">{{ $t('app.footer.eSim') }}</router-link></li>
              <li><router-link to="/products/esim">{{ $t('app.footer.fiveGInternationalRoaming') }}</router-link></li>
            </ul>
            <!-- <p>Orange Mobile 提供全球范围内的移动通信服务，让您随时随地保持连接。</p> -->
          </div>
        </el-col>

        <!-- 快速链接 -->
        <el-col :span="6">
          <div class="footer-section">
            <h3>{{ $t('app.footer.aboutTitle') }}</h3>
            <ul>
              <li><router-link to="/business">{{ $t('app.footer.whoWeAre') }}</router-link></li>
              <li><router-link to="/business">{{ $t('app.footer.businessCooperation') }}</router-link></li>
              <li><router-link to="/business">{{ $t('app.footer.shopForBusiness') }}</router-link></li>
              <li><router-link to="/support">{{ $t('app.footer.contactUs') }}</router-link></li>
            </ul>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="footer-section">
            <h3>{{ $t('app.footer.supportTitle') }}</h3>
            <ul>
              <li><router-link to="/products/esim">{{ $t('app.footer.productList') }}</router-link></li>
              <li><router-link to="/business">{{ $t('app.footer.howItWorks') }}</router-link></li>
              <li><router-link to="/support">{{ $t('app.footer.faq') }}</router-link></li>
            </ul>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="footer-section">
            <h3>{{ $t('app.footer.downloadAppTitle') }}</h3>
            <ul class="contact-info">
              <li>
                <img src="../../assets/images/logo.png" alt="Location" class="contact-icon">
                {{ $t('app.footer.companyAddress') }}
              </li>
              <li>
                <img src="../../assets/images/app/app.png" alt="iphone" class="contact-icon">
              </li>
              <li>
                <img src="../../assets/images/app/google.png" alt="Google" class="contact-icon">
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
      <div class="footer-content">
        <h2 class="company-name">{{ $t('app.footer.companyName') }}</h2>
        <p>{{ $t('app.footer.businessHallText') }}</p>
        <div class="payment-icons">
          <img  src="../../assets/images/pay/paypal.png" class="payment-icon">
          <img  src="../../assets/images/pay/stripe.png" class="payment-icon">
          <img  src="../../assets/images/pay/visa.png" class="payment-icon">
          <img  src="../../assets/images/pay/master-card.png" class="payment-icon">
          <img  src="../../assets/images/pay/google.png" class="payment-icon">
          <img  src="../../assets/images/pay/apple.png" class="payment-icon">
        </div>
      </div>
      <!-- 版权信息 -->
      <div class="footer-bottom">
        <p>{{ $t('app.footer.copyright') }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
};
</script>

<style lang="less" scoped>
.app-footer {
  background-color: #f5f7fa;
  padding: 60px 0 20px;
  color: var(--text-regular);

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .footer-section {
    margin-bottom: 30px;

    h3 {
      font-size: 18px;
      margin-bottom: 20px;
      color: var(--text-primary);
      position: relative;
      padding-bottom: 10px;

    }
    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        margin-bottom: 10px;

        a {
          font-size: 18px;
          color: var(--text-regular);
          text-decoration: none;
          transition: color 0.3s;
          font-weight: bold; // 字体加粗
          display: inline-block; // 转换为行内块元素，方便添加内边距
          padding: 4px 6px; // 添加上下内边距
          border-radius: 4px; // 添加圆角

          &:hover {
            color: var(--primary-color);
            background-color: rgba(64, 158, 255, 0.1); // 悬停时添加半透明背景
            transform: translateX(5px); // 悬停时向右偏移
          }
        }
      }
    }

    .contact-info {
      li {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        // 新增图片样式
        .contact-icon {
          height: 50px; // 图片高度
          margin-right: 10px; // 图片与文字间距
          object-fit: contain; // 保持图片比例
        }
      }
    }
    
  }
  .footer-content {
    border-top: 1px solid var(--border-color);
    text-align: center;
    margin-top: 20px;

    .company-name {
      font-size: 40px;
      font-weight: bold;
      color: #00c853;
      padding-top: 20px; 
    }
    p{
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 30px;
    }

    .payment-icons {
      display: flex;
      justify-content: center;
      gap: 15px; // 设置图标之间的间距

      .payment-icon {
        height: 30px; // 设置图标高度
        object-fit: contain; // 保持图片比例
      }
    }
  }
  .footer-bottom {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid var(--border-color);
    text-align: center;
    color: var(--text-secondary);
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .app-footer {
    padding: 40px 0 20px;

    .container {
      padding: 0 15px;
    }

    .footer-section {
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 0;
      }
      
    }
  }
}
</style> 
